import Super from 'ember-simplepractice/components/shared/unsupported-browser-modal';
import classic from 'ember-classic-decorator';
import styles from './unsupported-browser-modal.module.scss';

@classic
export default class SharedUnsupportedBrowserModal extends Super {
  styles = styles;
}
